import axios from 'axios';
import app from './main';
import auth from '@/service/auth'

axios.interceptors.request.use(async function (config) {
  app.$Progress.start();

  // auth.calcula_expiracion()
  if (config['headers']["Authorization"]) return config;

  const run = localStorage.getItem(`CognitoIdentityServiceProvider.${process.env.VUE_APP_COGNITO_CLIENT_ID}.LastAuthUser`)

  const auth_token = localStorage.getItem(`CognitoIdentityServiceProvider.${process.env.VUE_APP_COGNITO_CLIENT_ID}.${run}.idToken`);

  if (auth_token) config['headers']["Authorization"] = `Bearer ${auth_token}`

  config['headers']['Content-Type'] = `application/json`
  config['headers']['Accept'] = 'application/json; charset=utf-8'

  return config;
}, function (err) {
  app.$Progress.fail()
  return Promise.reject(err)
});

axios.interceptors.response.use(
  function (response) {
    app.$Progress.finish();
    if (response.status === 200 || response.status === 201) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  function (error) {
    app.$Progress.fail()

    if (error.request.status !== 401) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
    if ([401, 403].indexOf(error.request.status) !== -1) {
      console.log("The incoming token has expired")

      auth.auth.signOut()
    }
    return Promise.reject(error)
  }
);

export default axios;
